<template>
  <div class="values__item">
    <img
      v-if="item.icon"
      v-lazy-load
      :data-src="item.icon"
      alt=""
      class="values__icon"
    >
    <div
      v-else-if="isNumbered"
      class="values__number"
    >
      {{ index }}
    </div>
    <template v-else>
      <div></div>
    </template>
    <h3
      v-if="item.title"
      class="values__title"
      v-html="item.title"
    ></h3>
    <div
      class="values__description"
      v-html="item.description"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValuesItem',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isNumbered: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.values__icon {
  margin-bottom: 24px;
  width: auto;
  max-height: 72px;

  @media (max-width: $breakpoint-lg) {
    max-height: 64px;
  }

  @media (max-width: $breakpoint-sm) {
    max-height: 48px;
  }
}

.values__number {
  margin-bottom: 24px;
  color: $secondary;
  font-size: 87px;
  line-height: 1;

  @media (max-width: $breakpoint-lg) {
    font-size: 64px;
  }

  @media (max-width: $breakpoint-sm) {
    font-size: 48px;
  }

  .values--darkness & {
    color: #FFF;
  }
}

.values__title {
  margin-bottom: 16px;
}

.values__description {
  *:last-child {
    margin-bottom: 0;
  }
}
</style>